import styled from "@emotion/styled";

export const TruckInfoWrapper = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	display: "flex",
	flexDirection: "column",
	gap: 16,
	padding: "1.25rem",
	boxSizing: "border-box",
	width: "100%",
	"> span:first-of-type": {
		...theme.project.typography.subtitle.subtitle1,
		color: theme.project.colors.fontColors.secondary
	},
	"> span:nth-of-type(2)": {
		...theme.project.typography.body.body2,
		color: theme.project.colors.fontColors.secondary
	}
}));

export const TruckInfoAutocompletes = styled.div(({ theme }) => ({
	display: "flex",
	gap: 16,
	justifyContent: "space-between",
	div: {
		flex: 1
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));
